import React, { Component } from 'react'
import { Modal, Row } from 'antd'
import VehicleForm from './VehicleForm'

class VehicleModal extends Component {
  render() {
    const { visibleVehicle, onCancelVehicle, updateVehicle, submittingVehicle, vehicleFormRef } = this.props
    return (
      <Modal
        visible={visibleVehicle}
        title={'Vehicle'}
        onCancel={onCancelVehicle}
        onOk={updateVehicle}
        okText={'Update'}
        destroyOnClose={true}
        confirmLoading={submittingVehicle}
        width={'95%'}>
        <Row>
          <VehicleForm ref={vehicleFormRef} {...this.props} />
        </Row>
      </Modal>
    )
  }
}

VehicleModal.propTypes = {}
VehicleModal.defaultProps = {}

export default VehicleModal
